import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/lessons', parameters);
    }

    async getAll(params = {}) {
        return this.submit('get', '/all', params);
    }


    async updateLessonStatus(id, params = {}) {
        return this.submit('post', `/update/status/${id}`, params);
    }

    async trackProgress(id, params) {
        return this.submit('get', `/track/${id}`, params);
    }
    async duplicate(id, params) {
        return this.submit('post', `/duplicate/${id}`, params);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/Lesson.js